import { DataSourceAction, DataSourceExecutionEvent } from "@mcleod/components";
import { ModelRow, Navigation } from "@mcleod/core";
import { AutogenLayoutCurrentExchangeRates } from "./autogen/AutogenLayoutCurrentExchangeRates";

const exchangeRateListUrl = "lme/general/multicurrency/ExchangeRateList";

export class CurrentExchangeRates extends AutogenLayoutCurrentExchangeRates {

    private convertObjectToModelRow(modelUrl: string, data: []): ModelRow[] {
        if (data == null) {
            return;
        }

        const modifiedData: ModelRow[] = [];
        for (const d of data) {
            const modelRow = new ModelRow(modelUrl, false, d);
            modifiedData.push(modelRow);
        }

        return modifiedData;
    }

    sourceCurrentExchangeRatesAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.SEARCH) {
            this.addLayoutDataLoadListener(() => {
                const convertedRows = this.convertObjectToModelRow("lme/general/multicurrency/current-exchange-rates", this.sourceCurrentExchangeRates.data[0]?.get("exchange_rate_data"));
                this.sourceCurrentExchangeRates.data = convertedRows;
                this.sourceCurrentExchangeRates.displayDataInBoundComponents();
            });
        }
    }

    tableExchangeRatesOnClick() {
        Navigation.navigateTo(exchangeRateListUrl);
    }
}
